"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceVals = exports.codes = exports.codeNumber = void 0;
var _lodash = require("lodash");
var codes = {
  ERR400: 'Bad request',
  ERR400_1: 'Account creation failed.',
  ERR400_2: 'Resource not available.',
  ERR400_3: 'Entered password does not match.',
  ERR400_5: 'Patient creation failed.',
  ERR400_6: 'Cancel subscription failed.',
  // ERR400_7: 'stripe: create customer failed',
  // ERR400_8: 'stripe: create payment method failed',
  ERR400_9: 'Create plan failed.',
  ERR400_10: 'Create product failed.',
  // ERR400_11: 'stripe: create subscription failed',
  // ERR400_12: 'stripe: update customer failed',
  ERR400_13: 'Create patient failed.',
  ERR400_14: 'eRx ID is not assigned. Please contact support.',
  ERR400_15: 'Patient already exists.',
  ERR400_16: 'eRx ID is invalid.',
  ERR400_17: 'Coupon is invalid.',
  ERR400_18: 'Overlapping group sessions are not allowed.',
  ERR400_19: 'Group session capacity cannot be less than RSVP count.',
  // ERR400_21: 'stripe: cannot update payment method',
  ERR400_22: 'Please check if the card is still valid and has enough funds available.',
  ERR400_26: 'Attempt to create initial payment failed.',
  ERR400_27: 'Entered password does not meet requirements.',
  ERR400_28: 'Cannot join chat. Please try later.',
  ERR400_29: 'Please enter a valid card number.',
  ERR400_30: 'Please enter a valid expiration year.',
  ERR400_31: 'Please enter a valid expiration month.',
  ERR400_32: 'Please enter a valid security code.',
  ERR400_39: 'Account is already connected to the call.',
  ERR400_42: 'Please provide a valid file type.',
  ERR400_49: 'This clinician is matched to patients. Please unmatch them before setting to inactive.',
  ERR400_68: 'Failed to update phone number.',
  ERR400_58: 'Nickname is already in use.',
  ERR400_78: 'Unfortunately this time is no longer available. Please choose another one.',
  ERR400_79: 'Unable to create appointment at the selected time. Please try again.',
  ERR400_80: 'Cannot create an appointment for selected time slot. Please contact support for refund',
  // When Cronofy returns a 404. Can occur if clinician has connected and disconnected a calendar.
  // This is just the default message (can be more specific for admins/clinicians elsewhere).
  ERR400_84: 'There was a problem saving this appointment. Please try again later or contact support for assistance.',
  ERR400_85: 'Appointment time should be at least 24 hours in advance. Please choose another one',
  ERR400_99: 'The calendar you tried to connect is already in use for another account. Please contact support to resolve this issue.',
  ERR400_105: 'Topic is already in use.',
  ERR400_109: 'This coupon can only be used once your insurance has been determined to be eligible.',
  ERR400_110: 'No eligible insurance found to apply to subscription. Please contact support.',
  ERR400_119: 'There was a problem with your insurance card information. Please double-check that everything is correct.',
  ERR401_1: 'Login failed.',
  ERR403_1: 'Role not found.',
  ERR403_2: 'Role was not assigned.',
  ERR403_3: 'Token request failed.',
  ERR404_1: 'Role not found.',
  ERR404_2: 'Clinician not found.',
  ERR404_3: 'Patient not found.',
  ERR404_4: 'This referral code is invalid.',
  ERR404_10: 'Patient not found.',
  ERR404_11: 'Attempt to create subscription failed.',
  ERR404_12: 'Payment method ID is undefined.',
  ERR404_13: 'Plan ID is undefined.',
  ERR404_14: 'Account not found.',
  ERR404_15: 'Image not found.',
  ERR404_16: 'No available subscriptions for patient.',
  // ERR404_21: 'payment-svc: getting customer transaction history failed',
  // ERR404_22: 'payment-svc: getting customer payment method failed',
  ERR404_23: 'Active call not found.',
  ERR500: 'Please try again.',
  ERR500_1: 'Change password failed.'
};
exports.codes = codes;
var codeNumber = {
  NICKNAME_ALREADY_IN_USE: 'ERR400_58',
  EMAIL_CHANGE_FAILED: 'ERR400_64',
  EMAIL_ALREADY_IN_USE: 'ERR400_61',
  GOOGLE_EMAIL_CHANGE_FAILED: 'ERR400_71',
  NO_ACTIVE_CALL_CODE: 'ERR404_23',
  NO_AVAILABLE_SUBSCRIPTIONS_FOR_PATIENT_CODE: 'ERR404_16',
  FORBIDDEN: 'ERR403'
};
exports.codeNumber = codeNumber;
var SENTENCE_SEPARATOR = '. ';
var replaceVals = function replaceVals(string) {
  var valuesObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var resultString = string;
  var items = Object.getOwnPropertyNames(valuesObj);
  for (var i = 0; i < items.length; i++) {
    var regexp = new RegExp('{' + items[i] + '}');
    resultString = resultString.replace(regexp, valuesObj[items[i]]);
  }
  return typeof resultString === 'string' ? resultString.split(SENTENCE_SEPARATOR).map(_lodash.capitalize).join(SENTENCE_SEPARATOR) : resultString;
};
exports.replaceVals = replaceVals;